"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BtInstallmentsInline = BtInstallmentsInline;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _LocalizedCurrency = _interopRequireDefault(require("@/components/LocalizedCurrency"));
var InstallmentsCurrency = _LocalizedCurrency["default"];
/** Summarize the selected payment terms and open the plan selector. */
function BtInstallmentsInline(_ref) {
  var maxMonths = _ref.maxMonths,
    onOpen = _ref.onOpen,
    selectedMonths = _ref.selectedMonths,
    selectedPlan = _ref.selectedPlan,
    totalAmount = _ref.totalAmount;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var isSingle = !selectedPlan || selectedMonths <= 1;
  var amount = isSingle ? totalAmount : selectedPlan.monthlyPayment;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full overflow-hidden rounded-[30px] border-2 border-success-regular bg-white shadow-none transition-all duration-300 ease-in-out hover:shadow-sm focus-within:ring-2 focus-within:ring-success-regular/20",
    "data-sentry-component": "BtInstallmentsInline",
    "data-sentry-source-file": "BtInstallmentsInline.tsx"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex min-h-[72px] w-full cursor-pointer items-center justify-between gap-3 px-4 py-3 text-left max-sm:flex-col max-sm:items-stretch",
    onClick: onOpen,
    "aria-label": t('bt_installments.inline.cta_open')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex min-w-0 items-center gap-[10px]"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-success-regular/10",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-flex scale-[0.72]"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Success",
    color: "success",
    size: "M",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "BtInstallmentsInline.tsx"
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex min-w-0 flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "M",
    weight: "bold",
    color: "grayStrong",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "BtInstallmentsInline.tsx"
  }, isSingle ? t('bt_installments.inline.single_pay_short') : t('bt_installments.inline.payments_count_label', {
    count: selectedMonths
  })), amount !== undefined && /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    color: "grayMedium"
  }, "".concat(t('bt_installments.inline.amount_prefix'), " "), /*#__PURE__*/_react["default"].createElement(InstallmentsCurrency, {
    price: amount,
    currencyStyle: "currency",
    color: "grayMedium",
    size: "XS",
    weight: "regular",
    currencyLowercase: true,
    showCurrencySuffix: true
  })))), maxMonths > 1 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex flex-shrink-0 items-center gap-[10px] rounded-full bg-gray-100 px-[14px] py-2 max-sm:w-full max-sm:justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    weight: "semibold",
    color: "grayStrong"
  }, isSingle ? t('bt_installments.inline.cta_pay_up_to', {
    months: maxMonths
  }) : t('bt_installments.inline.cta_change_terms')), /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-flex",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "ChevronRight",
    color: "grayMedium",
    size: "S"
  })))));
}